import noop from 'utils/noop';

export const useLoyaltyUserState = () => ({
  loyaltyUser: null,
  error: null,
  refetch: noop,
  loading: false,
});
